export default function invoiceNumGreaterThanDirective(app) {
	app.directive('invoiceNumGreaterThan', [
		function () {
			var link = function ($scope, $element, $attrs, ctrl) {

				var toValiditableFormat = function (input) {
					return parseInt((input + '').replace(/[^0-9]/g, ''));
				};

				var validate = function (viewValue) {
					var comparisonModel = $attrs.invoiceNumGreaterThan;

					if (!viewValue) {
						ctrl.$setValidity('required', false);
					}

					ctrl.$setValidity('invoiceNumGreaterThan', toValiditableFormat(viewValue) > toValiditableFormat(comparisonModel));
					return viewValue;
				};

				ctrl.$parsers.unshift(validate);
				ctrl.$formatters.push(validate);

				$attrs.$observe('invoiceNumGreaterThan', function () {
					return validate(ctrl.$viewValue);
				});

			};

			return {
				require: 'ngModel',
				link: link
			};
		}
	]);
}
